import { memo } from 'react';
import { useTranslation } from 'react-i18next';

import { Flex } from '@/lib/v2/components/Layout/Stack';
import Select, { Option } from '@/lib/v2/components/Select/Select';

import { ITableMappingField } from './ContactsMappingField';

interface SelectRowProps {
  value: ITableMappingField;
  listCustomField: Option[];
  onChange: (option: Option, id: string | number, selectIndex: number) => void;
  onchangeDataType: (option: Option, id: string | number) => void;
  id: string | number;
  option: Option;
  selectDataType: Option[] | undefined;
  selected: Option;
  isInvalid: boolean;
  selectIndex: number;
}

function SelectRow({
  value,
  listCustomField,
  onChange,
  onchangeDataType,
  selectIndex,
  id,
  option,
  selectDataType,
  selected,
  isInvalid,
}: SelectRowProps) {
  const { t } = useTranslation();

  const handleOnChange = (e: Option | Option[]) => {
    onChange(e as Option, id, selectIndex);
  };

  const handleDataType = (e: Option | Option[]) => {
    onchangeDataType(e as Option, id);
  };

  return (
    <Flex key={`fieldMappingRow-${value.idColumn}`} withGap alignment="start" itemAlignment="start">
      <Flex>
        <Select
          id={`import-mapping-select-field-${value.idColumn}-${id}`}
          options={listCustomField}
          value={option}
          onChange={handleOnChange}
        />
      </Flex>
      <Flex column itemAlignment="start">
        {selectDataType && id !== -1 ? (
          <>
            <Select
              id={`import-mapping-select-format-${value.idColumn}-${id}`}
              options={selectDataType}
              value={selected}
              onChange={handleDataType}
            />
            {isInvalid && <span className="text-rose-600">{t('IMPORT_MAIN.invalidFormat')}</span>}
          </>
        ) : (
          <></>
        )}
      </Flex>
    </Flex>
  );
}

export default memo(SelectRow);
